import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    addItemToWishlist,
    getWishlistItems,
} from "../actions/wishListActions";

const WishlistSync = () => {
    const dispatch = useDispatch();

    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;

    const wishlist = useSelector((state) => state.wishlist);
    const { wishlistItems } = wishlist;

    useEffect(() => {
        if (userInfo) {
            // Step 1: Get server-side wishlist after login
            dispatch(getWishlistItems());
        }
    }, [dispatch, userInfo]);

    useEffect(() => {
        if (userInfo && wishlistItems) {
            const savedWishlist = JSON.parse(localStorage.getItem("savedWishlist"));

            if (savedWishlist && savedWishlist.length > 0) {
                savedWishlist.forEach((item) => {
                    const alreadyExists = wishlistItems?.some(
                        (w) => w._id === item._id
                    );
                    if (!alreadyExists) {
                        dispatch(addItemToWishlist(item._id));
                    }
                });

                localStorage.removeItem("savedWishlist");

                // Dispatch custom event to notify wishlist updated
                window.dispatchEvent(new Event("localWishlistUpdated"));
            }
        }
    }, [userInfo, dispatch, wishlistItems]);

    return null; // this component doesn’t render anything
};

export default WishlistSync;
